import { render, staticRenderFns } from "./BreakpointInputs.vue?vue&type=template&id=80091cd4&"
import script from "./BreakpointInputs.vue?vue&type=script&lang=ts&"
export * from "./BreakpointInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports